var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c("strong", [
                                  _vm._v("Confirm Availability and Total Rate"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "3" } }, [
                                _c("strong", [_vm._v("Total Rate:")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "9" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { wrap: "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-radio-group",
                                            {
                                              attrs: {
                                                row: "",
                                                autocomplete: "",
                                              },
                                              model: {
                                                value: _vm.quoteNotPossible,
                                                callback: function ($$v) {
                                                  _vm.quoteNotPossible = $$v
                                                },
                                                expression: "quoteNotPossible",
                                              },
                                            },
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label:
                                                    "A quote cannot be given at this time",
                                                  value: 1,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "A quote can be given",
                                                  value: 0,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-container",
                                            { attrs: { fluid: "" } },
                                            [
                                              _c(
                                                "v-layout",
                                                { attrs: { row: "" } },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "3" } },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          "Non-Commissionable Extras"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "9" } },
                                                    [
                                                      _vm._v(
                                                        "\n                                                  Non-Commissionable Extras \n                                              "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "3" } },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          "Total Cost Inclusive"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "9" } },
                                                    [
                                                      _vm._v(
                                                        "\n                                                  Total Cost Inclusive\n                                              "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "3" } },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          "Total Quote " +
                                                            _vm._s(
                                                              _vm.reservation
                                                                .hotel.currency
                                                                .currency_code
                                                            ) +
                                                            ":"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "9" } },
                                                    [
                                                      _c("v-text-field", {
                                                        staticClass:
                                                          "text-right align-right",
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.updateSeparateRatesFromTotalRates()
                                                          },
                                                        },
                                                        model: {
                                                          value: _vm.totalRates,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.totalRates = $$v
                                                          },
                                                          expression:
                                                            "totalRates",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "3" } }, [
                                _c("strong", [_vm._v("Deposit:")]),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "9" } }, [
                                _vm.reservation.depositRequired
                                  ? _c("div", [
                                      _c("strong", [
                                        _vm._v(
                                          "Deposit required at time of booking " +
                                            _vm._s(
                                              _vm.reservation
                                                .deposit_amount_local
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.reservation.hotel.currency
                                                .currency_code
                                            )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.reservation.is_advance_payment
                                  ? _c("div", [
                                      _vm._v(
                                        "Full pre-payment charged to the client by i-escape to secure the booking"
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.reservation.is_advance_payment &&
                                _vm.reservation.type_of_hotel == "UPF" &&
                                _vm.reservation.hotel.collect_deposit == 1
                                  ? _c("div", [
                                      _vm._v(
                                        "Amount charged to the client by i-escape to secure the booking"
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.reservation.is_advance_payment &&
                                _vm.reservation.type_of_hotel == "ARR" &&
                                !_vm.reservation.voucher_key
                                  ? _c("div", [
                                      _vm._v(
                                        "i-escape has not charged the clients card"
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "3" } }, [
                                _c("strong", [_vm._v("Payment Policy:")]),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "9" } }, [
                                _vm._v(
                                  "\n                                  To do\n                              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "3" } }, [
                                _c("strong", [_vm._v("Cancellation Policy:")]),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "9" } }, [
                                _c("textarea"),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "3" } }, [
                                _c("strong", [_vm._v("Quote Valid Until")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "9" } },
                                [
                                  _c("v-date-picker", {
                                    attrs: { "no-title": "", scrollable: "" },
                                    model: {
                                      value: _vm.reservation.quote_expiry,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.reservation,
                                          "quote_expiry",
                                          $$v
                                        )
                                      },
                                      expression: "reservation.quote_expiry",
                                    },
                                  }),
                                  _vm._v(
                                    " at midnight (GMT)\n                               "
                                  ),
                                  _c("div", [
                                    _c("strong", [_vm._v("NOTE")]),
                                    _vm._v(
                                      " this shows " +
                                        _vm._s(
                                          _vm.reservation.hotel.holds_rooms
                                        ) +
                                        " days from now. Please change it if you cannot keep the room/s on option for " +
                                        _vm._s(
                                          _vm.reservation.hotel.holds_rooms
                                        ) +
                                        " days. Ensure that you keep the accommodation/service quoted on available for the specified validity period."
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ies-green",
                          on: { click: _vm.sendQuote },
                        },
                        [_vm._v("Send to client")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }